export function browserSupportWebSpeechAPI() {
  const isChrome =
    /Chrome/.test(navigator.userAgent) && /Google Inc/.test(navigator.vendor);
  if (
    isChrome &&
    ("SpeechRecognition" in window || "webkitSpeechRecognition" in window)
  ) {
    // console.log("当前浏览器支持 Web Speech API");
    return true;
  } else {
    // console.log("当前浏览器不支持 Web Speech API");
    return false;
  }
}

/**
 * 截断文本到指定长度，超出部分用省略号替代
 * @param text 要截断的文本
 * @param maxLength 最大长度
 */
export const truncateText = (text: string, maxLength: number = 20): string => {
  if (!text) return '';
  return text.length > maxLength ? text.slice(0, maxLength) + '...' : text;
};
